<ng-container *ngIf="type === bannerType.maintenanceMode">
  <ng-container *ngTemplateOutlet="maintenanceModeBanner"></ng-container>
</ng-container>
<ng-container *ngIf="type === bannerType.tradingGlobal">
  <ng-container *ngTemplateOutlet="tradingGlobalBanner"></ng-container>
</ng-container>
<ng-container *ngIf="!type">
  <ng-container *ngTemplateOutlet="genericBanner"></ng-container>
</ng-container>

<ng-template #maintenanceModeBanner>
  <div class="hb-banner hb-banner--maintenance">
    <hb-icon class="hb-banner__icon" [ngClass]="['hb-banner__icon--' + type]" category="Information"
      name="AlertLineWhite" [size]="24"></hb-icon>
    <div class="hb-banner__message" [ngClass]="['hb-banner__message--' + type]">
      <p>{{ message }}</p>
    </div>
  </div>
</ng-template>

<ng-template #tradingGlobalBanner>
  <div class="hb-banner hb-banner--trading-global">
    <hb-icon class="hb-banner__icon" [ngClass]="['hb-banner__icon--' + type]" category="Location" name="Globe"
      [size]="20"></hb-icon>

    <div class="hb-banner__message" [ngClass]="['hb-banner__message--' + type]">
      <p>{{ message }}</p>
      <button type="button" class="button button--link typography-b-1 typography--semibold"
        (click)="bannerAction(bannerActions.continue)">
        Comenzar
      </button>
    </div>

    <div class="hb-banner__close">
      <button type="button" class="button button--link" (click)="bannerAction(bannerActions.close)">
        <img src="images/icons/strmn/userInterface/Close.svg" alt="close" />
      </button>
    </div>
  </div>
</ng-template>

<ng-template #genericBanner>
  <div class="hb-banner hb-banner--generic">
    <div class="hb-banner__icon">
      <hb-icon [category]="icon.category" [name]="icon.name" [invert]="true">
      </hb-icon>
    </div>

    <div class="hb-banner__message">
      <p>{{ message }}</p>
    </div>
  </div>
</ng-template>